import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=2e0d4245&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=2e0d4245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d4245",
  null
  
)

export default component.exports